import { useGetUser } from '@hero/services/organization-service/hooks';

function useSelectedOrganization() {
  const { data: user } = useGetUser();

  return user?.organizations?.find(org => org.code === user.selectedOrganizationCode);
}

export { useSelectedOrganization };
